//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
	name: 'Aktualita',

	async fetch ({ params, $axios, store }) {
		const response = await $axios.get('/blogs/read/' + params.slug);
		await store.dispatch('blogs/fetchBlogsBlog', response.data.payload);
	},

	head () {
		return {
			title: this.$config.webTitle[this.$i18n.locale] + ' - Aktuality',
			meta: [
				{
					name: 'description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
				{
					property: 'og:title',
					content: this.$config.webTitle[this.$i18n.locale],
				},
				{
					property: 'og:description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
			],
		};
	},

	computed: mapState({
		blog: (state) => state.blogs.blog,
	}),
};
